module.exports = __webpack_public_path__ + "static/media/back_line.868ff921.svg";